import type { HTMLAttributes } from 'react';

import { Separator } from '@change/ds-core-ui';

import { Waypoint } from 'src/app/shared/components/scroll';
import { SuggestedPetitionsLazy as SuggestedPetitionsLazySunrise } from 'src/app/shared/components/suggestedPetitionsLazySunrise';

import { usePageFooter } from './hooks/usePageFooter';

export function PageFooter(props: HTMLAttributes<HTMLDivElement>) {
	const {
		data: { petitionId },
		actions: { handleSuggestedPetitionsPosition },
	} = usePageFooter();

	return (
		<div className="pb-8" {...props}>
			<div>
				<Separator orientation="horizontal" className="mt-[52px] mb-2 md:mt-20" />
			</div>
			<Waypoint
				onPositionChange={({ currentPosition }) => handleSuggestedPetitionsPosition(currentPosition === 'below')}
			/>
			<SuggestedPetitionsLazySunrise
				channel="dm_responses"
				sourceLocation="dm_responses"
				petitionSlugOrId={petitionId}
			/>
		</div>
	);
}
